export default {
    validate: (value, termosInvalidos) => {

        value = ` ${value.trim()} `

        let valid = true

        termosInvalidos.forEach(termo => {

            if (new RegExp(` ${termo} `).test(value)) {

                valid = false

                return false
            }
        })

        return valid
    },
    message: '{_field_} possui um termo inválido.',
}